import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5587345c")

_pushScopeId("data-v-5587345c")
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "text-12px xxl:text-14px text-gray-lp-300 font-semibold" }
const _hoisted_3 = { class: "flex flex-grow text-14px text-gray-lp-300" }
const _hoisted_4 = {
  key: 2,
  class: "ml-4"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "border-b border-gray-lp-400" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold text-14px p-4 text-gray-lp-300" }, "Pilih jenis pembayaran")
], -1)
const _hoisted_6 = { class: "px-4 cursor-pointer" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "text-14px font-medium text-gray-lp-300 col-span-3" }, " Tunai ", -1)
const _hoisted_8 = { class: "text-14px font-medium text-gray-lp-300 col-span-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Cash = _resolveComponent("Cash")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('bookingShipment.payment.title')), 1),
    (_ctx.paymentMethodActive.name)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "flex items-center cursor-pointer select-none border border-gray-lp-400 rounded-md py-1 px-1 bg-white",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePaymentMethods && _ctx.togglePaymentMethods(...args))),
          style: {"height":"36px"}
        }, [
          (_ctx.paymentMethodActive.name === 'cash')
            ? (_openBlock(), _createBlock(_component_Cash, {
                key: 0,
                class: "text-red-lp-300 w-4 mr-3 ml-2"
              }))
            : (_openBlock(), _createBlock("img", {
                key: 1,
                alt: "payment-logo",
                class: "self-center w-4 mr-3 ml-2",
                src: 
          require(`@/app/ui/assets/svg/payment/${_ctx.paymentMethodActive.logo}2-active.svg`)
        
              }, null, 8, ["src"])),
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.accountIsNonForeign ? _ctx.paymentMethodActive.title : _ctx.$t('bookingShipment.payment.cash')), 1),
          (_ctx.accountIsNonForeign)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("img", {
                  alt: "",
                  class: "cursor-pointer select-none  w-4",
                  src: 
            require(`@/app/ui/assets/svg/${
              _ctx.showPaymentMethods ? 'chevron-up-new' : 'chevron-down-new'
            }.svg`)
          
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: "absolute border-l w-72 border-r flex flex-col bg-white rounded-lg shadow top-parent z-50",
      style: `margin-top: ${_ctx.isDiscount ? '50px' : '25px'};`
    }, [
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("div", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.payWithCash && _ctx.payWithCash(...args))),
          class: "flex flex-row gap-2 pt-4 pb-4 items-center"
        }, [
          _createVNode(_component_Cash, { class: "text-red-lp-300 w-6 self-center" }),
          _hoisted_7
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (payment, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            onClick: ($event: any) => (_ctx.payWithQr(payment)),
            class: "flex flex-row gap-2 pb-4 items-center"
          }, [
            _createVNode("img", {
              alt: "payment-logo",
              class: "self-center w-6",
              src: 
                require(`@/app/ui/assets/svg/payment/${payment.logo}2-active.svg`)
              
            }, null, 8, ["src"]),
            _createVNode("div", _hoisted_8, _toDisplayString(payment.title), 1)
          ], 8, ["onClick"]))
        }), 128))
      ])
    ], 4), [
      [_vShow, _ctx.showPaymentMethods]
    ])
  ], 512)), [
    [_directive_click_outside, _ctx.forceClosePaymentMethods]
  ])
})